module.exports = __webpack_public_path__ + "img/logo_tibiyot.4239c7c0.png";